import { createGlobalStyle } from 'styled-components';

import ROOT_VARIABLES from './RootVariables';
import RESET_CSS from './ResetCSS';
import CUSTOM_CSS from './CustomCSS';

const GlobalStyles = createGlobalStyle`
    ${ROOT_VARIABLES}

    ${RESET_CSS}

    ${CUSTOM_CSS}
`;

export default GlobalStyles;
